module.exports = __webpack_public_path__ + "static/media/bling.c14792fa.png";